<template>
  <el-button
    type="text"
    @click="clickButton(row.ignoring?.id)"
  >
    {{ `${row.ignoring?.name}` }}
  </el-button>
</template>

<script lang="ts">
import {
  defineComponent, PropType,
} from 'vue';
import { BansList } from 'features/settings/bans/types/hubstr';

export default defineComponent({
  name: 'ResidentLink',
  props: {
    row: {
      type: Object as PropType<BansList>,
      required: true,
    },
    column: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  setup () {
    // @ts-ignore
    const clickButton = (residentId) => {
      window.open(`/residents/${residentId}`, '_blank');
    };

    return {
      clickButton,
    };
  },
});
</script>
